<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="form-panel__thanks form-panel d-flex flex-column align-center px-10 mb-16">
    <div class="d-flex flex-column align-center w-100" style="max-width: 370px">
      <div class="d-flex flex-column align-center w-100 mb-5">
        <div class="text-h5 text-uppercase font-weight-bold" style="max-width: 220px">
          {{ heading }}
        </div>
      </div>

      <v-img
        class="mb-5"
        :src="require('../../assets/images/donation-flow-thank-you.png')"
        :srcset="`
          ${require('../../assets/images/donation-flow-thank-you.png')} 1x,
          ${require('../../assets/images/donation-flow-thank-you@2x.png')} 2x,
          ${require('../../assets/images/donation-flow-thank-you@3x.png')} 3x
        `"
      />
      <div v-if="fundraiserUI.premium_campaign && fundraiserUI.eligible_for_premium">
        <form ref="form" class="premium_form" @submit="sendPremium">
          <p class="font-bold">{{ $t('action.panels.FUNDRAISER_THANKS.premiumIntro', locale) }}</p>
          <v-text-field
            :value="formData.first_name"
            :label="$t('action.panels.FUNDRAISER_THANKS.firstName', locale)"
            name="first_name"
            required="required"
          >
          </v-text-field>
          <v-text-field
            name="last_name"
            :value="formData.last_name"
            :label="$t('action.panels.FUNDRAISER_THANKS.lastName', locale)"
            required
          >
          </v-text-field>
          <v-text-field
            name="email"
            :value="formData.email"
            :label="$t('action.panels.FUNDRAISER_THANKS.email', locale)"
            required
          ></v-text-field>
          <input name="donation" :value="fundraiserUI.donation" type="hidden" />

          <v-text-field
            :label="$t('action.panels.FUNDRAISER_THANKS.deliveryAddress', locale)"
            name="delivery_address_line_one"
            required
          >
          </v-text-field>
          <v-text-field
            :label="$t('action.panels.FUNDRAISER_THANKS.town', locale)"
            name="town_or_city"
            required
          >
          </v-text-field>
          <v-text-field
            :label="$t('action.ltt.fields.postalCode.label', locale)"
            name="postcode"
            required
          ></v-text-field>
          <v-text-field
            :label="$t('action.panels.FUNDRAISER_THANKS.country', locale)"
            :value="formData.country"
            name="country"
            required
          >
          </v-text-field>
          <div v-if="fundraiserUI.clothing_premium == true">
            <v-select
              if="fundraiserUI.clothing_premium==true"
              name="size"
              :label="$t('action.panels.FUNDRAISER_THANKS.size', locale)"
              :items="fundraiserUI.premium_sizes"
              required
              class="size flex-column"
            >
            </v-select>
          </div>
          <div class="d-flex flex-column align-center">
            <button class="btn btn-sign" type="submit">Submit</button>
          </div>
        </form>
      </div>
      <div class="mb-8">
        <div v-if="formConfig.form_submitted_tagline" v-html="formConfig.form_submitted_tagline" />
        <div v-if="!formConfig.form_submitted_tagline" class="mb-5">
          {{ $t('action.panels.FUNDRAISER_THANKS.defaultTagline1', locale) }}
        </div>
        <div v-if="!formConfig.form_submitted_tagline" class="font-weight-bold">
          {{ $t('action.panels.FUNDRAISER_THANKS.defaultTagline2', locale) }}
        </div>
      </div>

      <div class="d-flex justify-center w-100">
        <a
          class="mb-0 ml-2 mr-2"
          :href="formConfig.facebook_share_url"
          :alt="$t('action.panels.FUNDRAISER_THANKS.facebookAlt', locale)"
          target="_blank"
        >
          <FacebookSVG />
        </a>
        <a
          v-if="formConfig.bluesky_share_url"
          class="mb-0 ml-2 mr-2 bluesky-share"
          :href="formConfig.bluesky_share_url"
          :alt="$t('action.panels.FUNDRAISER_THANKS.blueskyAlt', locale)"
          target="_blank"
        >
          <BlueskySVG />
        </a>
        <a
          v-if="formConfig.whatsapp_share_url"
          class="mb-0 ml-2 mr-2"
          :href="formConfig.whatsapp_share_url"
          :alt="$t('action.panels.FUNDRAISER_THANKS.whatsappAlt', locale)"
          target="_blank"
        >
          <WhatsAppSVG />
        </a>
      </div>
    </div>
    <div class="mt-4">
      <copy-button />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { mdiArrowLeftBoldCircleOutline } from '@mdi/js'
import confetti from 'canvas-confetti'
import axios from 'axios'

import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../utils/tracking'

import FacebookSVG from '../../assets/images/symbols/facebook.svg?inline'
import BlueskySVG from '../../assets/images/symbols/bluesky.svg?inline'
import WhatsAppSVG from '../../assets/images/symbols/whatsapp.svg?inline'
import CopyButton from '../ui/CopyButton'

export default {
  name: 'PanelFundraiserThanks',
  components: {
    FacebookSVG,
    BlueskySVG,
    WhatsAppSVG,
    CopyButton
  },
  data: () => ({
    EVENT_CATEGORIES,
    icons: {
      mdiArrowLeftBoldCircleOutline
    }
  }),

  computed: {
    heading: vm =>
      vm.formConfig.form_submitted_heading ||
      vm.$t('action.panels.FUNDRAISER_THANKS.defaultHeading', vm.locale),
    ...mapState('actionForm', [
      'locale',
      'formConfig',
      'actionId',
      'formData',
      'baseUrl',
      'fundraiserUI',
      'formState'
    ]),
    ...mapGetters('actionForm', ['isLTT', 'isMemberGenerated', 'withConfetti'])
  },
  mounted() {
    if (this.withConfetti) {
      this.fireConfetti()
    }
    const form = document.querySelector('.premium_form')
    if (form) {
      form.removeAttribute('novalidate')
    }
  },
  methods: {
    fireConfetti() {
      // https://github.com/catdad/canvas-confetti
      const duration = 10 * 1000 // milliseconds
      const animationEnd = Date.now() + duration
      // Rainbow confetti colours
      // https://www.schemecolor.com/mixed-rainbow.php
      const rainbowColors = [
        '#FE3838', // Coral Red
        '#ECFF16', // Traditional Chartreuse
        '#71FC2D', // Spring Frost
        '#156EFF', // Crayola's Blue
        '#2BE4FF', // Fluorescent Blue
        '#FF1ACE' // Hot Magenta
      ]

      function randomInRange(min, max) {
        return Math.random() * (max - min) + min
      }

      function* makeColorIterator() {
        while (true) {
          for (const color of rainbowColors) {
            yield color
          }
        }
      }

      const colorIterator = makeColorIterator()

      const defaults = {
        particleCount: this.$vuetify.breakpoint.smAndDown ? 30 : 90,
        disableForReducedMotion: true,
        ticks: 150,
        spread: 150,
        decay: 0.9,
        scalar: 1.2,
        shapes: ['circle']
      }

      const vm = this
      const origin = {
        y: this.$vuetify.breakpoint.smAndDown ? 0.1 : 0.4
      }

      async function frame() {
        const { value } = colorIterator.next()
        const colors = [value]
        // Left
        setTimeout(
          () =>
            confetti({
              startVelocity: vm.$vuetify.breakpoint.smAndDown
                ? randomInRange(8, 20)
                : randomInRange(30, 50),
              angle: 80,
              colors,
              origin: { ...origin, x: 0 },
              ...defaults
            }),
          randomInRange(301, 800)
        )
        // Right
        setTimeout(
          () =>
            confetti({
              startVelocity: vm.$vuetify.breakpoint.smAndDown
                ? randomInRange(8, 20)
                : randomInRange(30, 50),
              angle: 111,
              colors,
              origin: { ...origin, x: 1 },
              ...defaults
            }),
          randomInRange(300, 800)
        )
        // Sleep
        const sleepMillis = randomInRange(300, 1200)
        await new Promise(resolve => setTimeout(resolve, sleepMillis))
        // Rerun if still within the duration time
        if (Date.now() < animationEnd) {
          requestAnimationFrame(frame)
        }
      }
      this.$nextTick(frame)
    },

    async sendPremium(event) {
      event.preventDefault()
      const form = event.target.closest('form')
      const formData = new FormData(form)
      const data = Object.fromEntries(formData)
      if (this.fundraiserUI.clothing_premium == true && data.size == '') {
        const input = form.querySelector('.size')
        input.append(this.$t('action.panels.FUNDRAISER_THANKS.sizeRequired', this.locale))
      } else {
        const response = await axios.post(
          `${this.baseUrl}/api/payments/premium/${this.actionId}/init/`,
          data
        )
        if (response.status == 201) {
          form.remove()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_panels-common.scss';
</style>
